//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios'

export default {
  name: 'ProductListModal',
  components: "",
  data () {
    return {
      awaitingSearch: false,
      loading: true,
      productList: [],
      productFilters: {
        afterCursor: "",
        beforeCursor: "",
        prevPage: "",
        nextPage: "",
        search: "",
        sortBy: "TITLE",
      },
      search: "",
      selectedVariant: 0
    }
  },
  props: ['bundle', 'storeDomain', 'title'],
  methods: {
    checkProduct(products, product) {
      return this.productList.find(bundleProduct => parseInt(bundleProduct.productId) === parseInt(product.id));
    },
    clearSearch() {
      this.productFilters.search = ""
      this.search = ""
      this.loadProducts('search')
    },
    async loadProducts(action) {
      this.loading = true
      try {
        await axios.post(
          "/api/starter/products",
          {
            shopDomain: this.storeDomain,
            action: action,
            productCount: 15,
            aCursor: this.productFilters.afterCursor,
            bCursor: this.productFilters.beforeCursor,
            prevPage: this.productFilters.prevPage,
            nextPage: this.productFilters.nextPage,
            search: this.productFilters.search,
            sortBy: this.productFilters.sortBy
          }).then((response) => {
          const productList = []
          const products = response.data.data.results.products.edges

          this.productFilters.prevPage = response.data.data.results.products.pageInfo.hasPreviousPage;
          this.productFilters.nextPage = response.data.data.results.products.pageInfo.hasNextPage;

          for (var i = 0; i < products.length; i++) {
            const product = products[i].node
            const productTitle = product.title
            const productId = (product.id).replace('gid://shopify/Product/', '')

            this.productFilters.beforeCursor = products[0].cursor
            this.productFilters.afterCursor = products[Math.abs(products.length - 1)].cursor

            var variants = []

            for (var v = 0; v < product.variants.edges.length; v++) {
              const variant = product.variants.edges[v].node
              const variantData = {
                id: (variant.id).replace('gid://shopify/ProductVariant/', ''),
                title: variant.title,
                image: variant.image !== null ? variant.image.src : ''
              }
              variants.push(variantData);
            }

            productList.push({
              id: productId,
              image: product.featuredImage !== null ? product.featuredImage.src : '',
              title: productTitle,
              handle: product.handle,
              selectedVariant: 0,
              variants: variants
            });
          }

          this.productList = productList
          this.loading = false

          this.$emit('products-loaded', this.productList)
        });
      } catch (e) {
        console.log(e);
      }
    },
    closeOverlay() {
      const data = {
        overlay: false
      }
      this.$emit('close-overlay', data)
    },
    chooseProduct(productId, variantId, productTitle, variantTitle, image,productHandle) {
      const data = {
        productId: productId,
        title: productTitle,
        image: image,
        quantity: 1,
        handle: productHandle,
        variantTitle: variantTitle,
        variantId: variantId
      }
      this.$emit('choose-product', data)
      this.closeOverlay();
    },
  },
  watch: {
    search: function (val) {
      if (!this.awaitingSearch) {
        setTimeout(() => {
          this.productFilters.search = val;
          this.loadProducts('search');
          this.awaitingSearch = false;
        }, 1500);
      }
      this.awaitingSearch = true;
    },
  },
  mounted () {
    this.loadProducts()
  }
}
